import { render } from "./FileHistory.vue?vue&type=template&id=0bbc2e7e&scoped=true"
import script from "./FileHistory.vue?vue&type=script&lang=js"
export * from "./FileHistory.vue?vue&type=script&lang=js"

import "./FileHistory.vue?vue&type=style&index=0&id=0bbc2e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbc2e7e"]])

export default __exports__